import styled from 'styled-components'

export const CheckboxElement = styled.div`
  div > div {
    font-family: 'Navigo', Arial, Helvetica, sans-serif;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 400;
    color: #292e3d;
  }

  span[class^='Checkboxstyled__CheckboxIndicator'] {
    border: 1px solid #c2c7d6 !important;
    box-shadow: none !important;
  }

  &:hover span[class^='Checkboxstyled__CheckboxIndicator'] {
    border: 1px solid #a3abc2 !important;
    box-shadow: none !important;
  }

  input:checked + span[class^='Checkboxstyled__CheckboxIndicator'] {
    background-color: #3a64f8 !important;
    border-color: #3a64f8 !important;
  }

  &:hover > input:checked + span[class^='Checkboxstyled__CheckboxIndicator'] {
    background: #6b8bfa !important;
    border: 1px solid #6b8bfa !important;
    box-shadow: none !important;
  }
`
